<div class="page-head">
  <div>
    <h1>Image Sizes</h1>
    <div class="sub">Find images missing resized copies — old uploads load full-size until generated</div>
  </div>
  <div class="head-actions">
    <select class="inp" [(ngModel)]="container" (ngModelChange)="onContainerChange()" [disabled]="scanning || runningAll">
      @for (c of containers; track c) {
        <option [value]="c">{{ c }}</option>
      }
    </select>
    <ng-container *staffCan="'Platform.Images.Generate'"><button type="button" class="act act-ghost" (click)="scan()" [disabled]="scanning || runningAll">
      {{ scanning ? 'Scanning…' : 'Re-scan' }}
    </button></ng-container>
    <ng-container *staffCan="'Platform.Images.Generate'"><button type="button" class="act" (click)="generateAll()" [disabled]="scanning || runningAll || pendingCount === 0">
      @if (runningAll) {
        Generating {{ allProgress }}/{{ allTotal }}…
      } @else {
        Generate all ({{ pendingCount }})
      }
    </button></ng-container>
  </div>
</div>

<div class="page-body">
  <div class="panel">
    <div class="panel-title">Images needing work — {{ container }}</div>

    @if (message) {
      <div class="note note-ok">{{ message }}</div>
    }
    @if (error) {
      <div class="note note-err">{{ error }}</div>
    }

    @if (scanning && !loaded) {
      <div class="scan-count">Listing the container…</div>
    }

    @if (loaded) {
      <div class="scan-count">
        {{ totalOriginals }} image{{ totalOriginals === 1 ? '' : 's' }} in '{{ container }}' —
        {{ totalComplete }} complete, {{ rows.length }} listed below
        @if (truncated) {
          <span class="scan-truncated">(more than fit one scan; generate these, then re-scan)</span>
        }
      </div>

      @if (rows.length === 0) {
        <div class="empty">Every image in this container already has its resized copies. Nothing to do.</div>
      }

      @if (rows.length > 0) {
        <ul class="img-list">
          @for (row of rows; track row.item.name) {
            <li class="img-row" [class.img-row-done]="row.result">
              <img class="img-thumb" [src]="thumbUrl(row.item.name)" alt="" loading="lazy" />
              <div class="img-main">
                <div class="img-name">{{ row.item.name }}</div>
                <div class="img-meta">
                  @if (row.item.sizeBytes !== null) {
                    <span>{{ sizeLabel(row.item.sizeBytes) }}</span>
                  }
                  @for (w of row.item.missingWidths; track w) {
                    <span class="chip">missing _{{ w }}</span>
                  }
                  @if (row.item.needsContentType) {
                    <span class="chip chip-warn">no content-type</span>
                  }
                </div>
              </div>
              @if (row.result) {
                <span class="img-status" [class.img-status-ok]="isOk(row.result)" [class.img-status-err]="!isOk(row.result)">
                  {{ statusLabel(row.result) }}
                </span>
              } @else {
                <ng-container *staffCan="'Platform.Images.Generate'"><button type="button" class="act act-ghost img-generate" (click)="generate(row)"
                        [disabled]="row.generating || runningAll">
                  {{ row.generating ? 'Generating…' : 'Generate' }}
                </button></ng-container>
              }
            </li>
          }
        </ul>
      }
    }

    <div class="hint">
      Copies are written at 240/480/960px next to each original, in the original's own encoding —
      existing copies are never overwritten, and the POS keeps falling back to the original until its
      copies exist. An image narrower than a size deliberately never gets that copy; generating it once
      records that, so it stops appearing here. Images with a missing content-type are repaired at the
      same time.
    </div>
  </div>
</div>
